module.exports = __webpack_public_path__ + "img/preparing-gray-icon.fee5a182.png";